module.exports = __webpack_public_path__ + "img/google-maps-icon.646f59e5.svg";